var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrending = function SvgTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.25 2.625v3a.375.375 0 11-.75 0V3.53L6.64 7.39a.375.375 0 01-.53 0L4.5 5.78 1.39 8.89a.375.375 0 11-.53-.53l3.375-3.375a.375.375 0 01.53 0l1.61 1.61L9.97 3H7.875a.375.375 0 010-.75h3a.375.375 0 01.375.375z"
  })));
};
export default SvgTrending;